module.exports = __webpack_public_path__ + "static/img/精密制造.b05ee276.png";